import { isNil } from "lodash";
import { Entite } from "./DataTypes";
import { Box } from "@mui/material";

interface EntiteDetailProps{
    ghost: Entite | null
}

const EntiteDetail = (props: EntiteDetailProps) => {

    if(isNil(props.ghost))
        return null;
    return <Box display={"flex"} flexDirection={"column"}>
        <Box>{props.ghost.name}</Box>
        <Box>Preuves : {props.ghost.preuves.map(x => x + ", ")}</Box>
        {!isNil(props.ghost.preuveObligatoire) && <Box sx={{fontWeight: "bold"}}>Preuve Obligatoire : {props.ghost.preuveObligatoire} </Box>}
        <Box>Sante Mental : {props.ghost.santeMental}</Box>
        <Box>Sante Mental (Pouvoir): {props.ghost.santeMentalPouvoir}</Box>
        <Box>Checks : </Box>
            {props.ghost.checks.map(c => {
                return <li>{c}</li>
            })}
    </Box>
}

export default EntiteDetail;